import PressurePage from "./pressure-page";

export default PressurePage;
